import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/layouts/default.vue").then(m => m.default || m)),
  "header-only": defineAsyncComponent(() => import("/var/www/layouts/header-only.vue").then(m => m.default || m))
}